class OrderToday {
  msgs = {
    open: 'We are open, time left to order:',
    weekdaysClosed: 'We are closed, you can order in:',
    afterFridayClosed: 'We are closed for the weekend you can order in:'
  };

  constructor(closedHour = 15, closedMinutes = 30) {
    this.closedHour = closedHour;
    this.closedMinutes = closedMinutes;

    // Element references
    const parent = document.querySelector('.lzm-order-today');
    this.els = {
      msg: parent.querySelector('.message'),
      timer: parent.querySelector('.time-left')
    };
  }

  startTicking(speed = 500) {
    this.intervalId = window.setInterval(this.tick.bind(this), speed);
  }

  stopTicking() {
    window.clearInterval(this.intervalId);
  }

  tick() {
    this.now = new Date();

    if (this.isOpen()) {
      this.els.msg.textContent = this.msgs.open;
    } else {
      if (this.isWeekDaysClosed()) {
        this.els.msg.textContent = this.msgs.weekdaysClosed;
      } else if (this.isAfterFridayClosed()) {
        this.els.msg.textContent = this.msgs.afterFridayClosed;
      }
    }
    this.updateTimer();
  }

  isPastTime(dt, hour, minutes) {
    return dt.getHours() > hour || (dt.getHours() === hour && dt.getMinutes() >= minutes);
  }

  isDayInRange(dt, range = [1, 2, 3, 4]) {
    return range.includes(dt.getDay());
  }

  isOpen() {
    return this.isDayInRange(this.now) && !this.isPastTime(this.now, this.closedHour, this.closedMinutes);
  }

  isWeekDaysClosed() {
    return this.isDayInRange(this.now) && this.isPastTime(this.now, this.closedHour, this.closedMinutes);
  }

  isAfterFridayClosed() {
    if (5 === this.now.getDay()) {
      return this.isPastTime(this.now, this.closedHour, this.closedMinutes);
    }
    return this.isDayInRange(this.now, [6, 0]);
  }

  getTimeLeft() {
    const now = this.now;
    let nextOpenTime = new Date();
    nextOpenTime.setHours(this.closedHour, this.closedMinutes, 0, 0);

    if (this.isWeekDaysClosed()) {
      nextOpenTime.setDate(now.getDate() + 1);
    } else if (this.isAfterFridayClosed()) {
      console.log('Next tuesday', now.getDate() + ((8 - now.getDay()) % 7) + 1);
      nextOpenTime.setDate(now.getDate() + ((8 - now.getDay()) % 7) + 1); // Next Tuesday
    }

    const timeLeft = nextOpenTime - now;
    return {
      days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeLeft % (1000 * 60)) / 1000),
    }
  }

  updateTimer() {
    const { days, hours, minutes, seconds } = this.getTimeLeft();
    if (days > 0) {
      this.els.timer.textContent = `${days} d ${hours} u ${minutes} m`;
    } else {
      this.els.timer.textContent = `${hours} u ${minutes} m`;
    }
    if (0 === hours) {
      this.els.timer.textContent = `${minutes} m ${seconds} s`;
    }
  }
}
// LZM